import React from 'react';
import styled from 'styled-components';
import { videoSort } from '../../util/constants';
import { SortTextButton, HEADING_STYLE } from '../sortTextButton';
import { videoGrid, TYPE_PILL_INSET, LABEL_PILL_INSET } from '../../util/ui';

const Bar = styled.div`
  box-sizing: border-box;
  /* UI refresh: neutral charcoal instead of dark green, so green only ever means "complete". */
  background-color: #2e333b;
`;

type Props = {
  currentSort: { sortType: videoSort; direction: 'asc' | 'desc' };
  update(sortType: videoSort, direction: 'asc' | 'desc'): void;
};

/**
 * Column headings for a record's files. Same columns as the file rows (util/ui VIDEO_COLUMNS), and each
 * heading starts where the text below it starts: the notes text, and the text inside the type and label
 * pills (Aaron, 5 Nov 2026). Rendered inside the files' scrolling box and kept at its top (sticky).
 */
export const VideoSortBar: React.FC<Props> = ({ currentSort, update }) => {
  const checkState = (sortType: videoSort): 'asc' | 'desc' | undefined =>
    currentSort.sortType === sortType ? currentSort.direction : undefined;
  const sortButton = (text: string, sortType: videoSort) => (
    <SortTextButton text={text} onClick={(direction) => update(sortType, direction)} state={checkState(sortType)} />
  );
  return (
    // archy-vhead: on a phone, a sideways strip of sort buttons (index.css). Its <span> cells are hidden there.
    <Bar className="archy-vhead" style={{ ...videoGrid, height: 32, position: 'sticky', top: 0, zIndex: 2 }}>
      <span />
      <div>{sortButton('Filename', videoSort.filename)}</div>
      <span style={HEADING_STYLE}>Notes</span>
      <div style={{ paddingLeft: TYPE_PILL_INSET }}>{sortButton('Type', videoSort.ext)}</div>
      <div>{sortButton('Size', videoSort.size)}</div>
      <div style={{ paddingLeft: LABEL_PILL_INSET }}>{sortButton('Label', videoSort.category)}</div>
      <div>{sortButton('Date', videoSort.date)}</div>
      <span />
    </Bar>
  );
};
